import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Notifice Management Services
 * !== 알림 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/ptl/noti`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/noti-mgmt`,
    nodes: [],
};

export const URLS = {
    ptli1010001q: `${BASE.path}/ptli1010001q`, // Notifice List !==  알림 목록 ==!
    ptli1010002s: `${BASE.path}/ptli1010002s`, // Notifice Registration !==  알림 등록 ==!
    ptli1010003s: `${BASE.path}/ptli1010003s`, // Modifying and deleting Notifice !==  면허알림 수정 ==!
    ptli1010004q: `${BASE.path}/ptli1010004q`, // Notifice Details !==  알림 상세 ==!
};

export const APIS = {
    // Check Notifice List !==  알림 목록 조회 ==!
    getNotiList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Notifice details inquiry !== 알림 상세 정보 조회 ==!
    getNotiInfo: (notiId: any) => {
        return api.get(`${BASE.api}/${notiId}`);
    },
    // Create Notifice !== 알림 생성 ==!
    createNoti: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update Notifice !==  알림 수정 ==!
    updateNoti: (data: any) => {
        return api.put(`${BASE.api}/${data.notiId}`, {
            ...data,
        });
    },
    // Delete Notifice !== 알림 삭제 ==!
    deleteNoti: (notiId: any) => {
        return api.delete(`${BASE.api}/${notiId}`);
    },
};

export const SF_NOTI_SRCH: TFormSchema = {
    id: "form_notiSrch",
    schema: {
        inexTpCd: { type: "select", label: "L_INEX_TP", all: true, area: "comnCd", comnCd: "CGM0176" },
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_NM", all: true, area: "comnCd", comnCd: "COM0024" },
        notiId: { type: "text", label: "L_NOTI_ID" },
        notiNm: { type: "text", label: "L_NOTI_NM", controlSize: 10 },
        notiTpSettValueList: {
            type: "checkbox",
            label: "L_NOTI_TP",
            options: [
                { label: "SMS", value: "1" },
                { label: "E-Mail", value: "2" },
            ],
            defaultValue: ["1", "2"],
        },
        useYn: {
            type: "select",
            label: "L_NOTI_YN",
            all: true,
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
    },
};

export const SG_NOTI_LIST: TGridSchema = {
    id: "grid_notiList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_NOTI_ID", binding: "notiId", width: "10%" }] },
        { cells: [{ header: "L_INEX_TP_NM", binding: "inexTpCdNm", width: "10%" }] },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }] },
        { cells: [{ header: "L_NOTI_TP_SETT_VALUE", binding: "notiTpSettValue", width: "15%" }] },
        { cells: [{ header: "L_NOTI_NM", binding: "notiNm", width: "*" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: "10%" }] },
    ],
    body: [
        {
            cells: [{ binding: "notiId" }],
        },
        {
            cells: [{ binding: "inexTpCdNm" }],
        },
        {
            cells: [{ binding: "bsopClsfCdNm" }],
        },
        {
            cells: [{ binding: "notiTpSettValue", align: "left" }],
        },
        {
            cells: [{ binding: "notiNm", align: "left" }],
        },
        {
            cells: [{ binding: "useYn" }],
        },
    ],
};

export const SF_NOTI_INFO: TFormSchema = {
    id: "form_notiInfo",
    schema: {
        inexTpCd: {
            type: "select",
            label: "L_INEX_TP",
            area: "comnCd",
            comnCd: "CGM0176",
            all: true,
            rows: 5,
            required: true,
        },
        notiId: {
            type: "text",
            label: "L_NOTI_ID",
            readOnly: true,
            placeholder: "자동생성",
        },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            area: "comnCd",
            comnCd: "COM0024",
            rows: 5,
            required: true,
        },
        notiTpCd: {
            type: "select",
            label: "L_NOTI_TP",
            area: "comnCd",
            comnCd: "PTL0020",
            rows: 5,
            required: true,
        },
        notiNm: { type: "text", label: "L_NOTI_NM", controlSize: 10, required: true },
        notiMsgEngCn: { type: "textarea", label: "L_NOTI_MSG_ENG_CN", controlSize: 10, rows: 5, required: true },
        notiMsgTzCn: { type: "textarea", label: "L_NOTI_MSG_TZ_CN", controlSize: 10, rows: 5 },
        notiMsgKoCn: { type: "textarea", label: "L_NOTI_MSG_KO_CN", controlSize: 10, rows: 5 },
        rcveNtfcRqrdYn: {
            type: "select",
            label: "L_RCVE_NTFC_RQRD_YN",
            required: true,
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            required: true,
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        notiTpSettValueList: {
            type: "checkbox",
            label: "L_NOTI_TP",
            options: [
                { label: "SMS", value: "1" },
                { label: "E-Mail", value: "2" },
            ],
            defaultValue: ["1", "2"],
            required: true,
        },
        bsopStatValue: { type: "text", label: "L_BSOP_STAT_VALUE" },
        sndrNm: { type: "text", label: "L_SNDR_NM" },
        sndrEmlAddr: {
            type: "text",
            label: "L_SNDR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
        },
        sndrTelno: { type: "text", label: "L_SNDR_TELNO" },
    },
};

interface SettingsMap {
    [key: number]: string;
}

export const SETTINGS_MAP: SettingsMap = {
    1: "SMS",
    2: "E-Mail",
    4: "Push Notification", // 예시로 추가된 설정
    // 필요에 따라 여기에 더 많은 설정을 추가할 수 있습니다.
};
